import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";
import { HeatMapItem } from "./HeatMapItem"
import "./style.css"
import { useParams } from 'react-router-dom';
let version: any



export const HeatMap = ({handleHeatMapClick, heatMapData, boxShadow, setboxShadow }: any) => {
    
    const { type }: any = useParams();
    version = 'all';

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 5
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    
    return (
        <><Carousel ssr className="heatmap1 heat-map-container"
            responsive={responsive}
            autoPlay={false}
            swipeable={false}
            draggable={true}
            showDots={false}
            infinite={false}
            partialVisible={false}
        >
            {heatMapData?.length > 0 && heatMapData?.map((data: any, i: any) => {
                return <HeatMapItem boxShadow={boxShadow} setboxShadow={setboxShadow} key={i} heatMapData={data} index={data.s_version}
                    handleHeatMapClick={handleHeatMapClick} type={type} identifier={data.identifier}/>
                }
            )}
        </Carousel>

        </>)
}